
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowRight } from "lucide-react";

interface NavigationButtonsProps {
  currentStage: number;
  totalStages: number;
  onPrevious: () => void;
  onNext: () => void;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  currentStage,
  totalStages,
  onPrevious,
  onNext,
}) => {
  const isFirstStage = currentStage === 0;
  const isLastStage = currentStage === totalStages - 1;

  // In management view, don't show navigation buttons
  if (currentStage >= 3) {
    return null;
  }

  return (
    <div className="flex justify-between mt-8">
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={isFirstStage}
        className={isFirstStage ? "opacity-0" : ""}
      >
        <ArrowLeft className="h-4 w-4 mr-2" />
        Previous
      </Button>
      
      <Button
        onClick={onNext}
        disabled={isLastStage}
        className={isLastStage ? "opacity-0" : ""}
      >
        Next
        <ArrowRight className="h-4 w-4 ml-2" />
      </Button>
    </div>
  );
};

export default NavigationButtons;
